// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"fingerprint"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M19.4965 21C20.4623 18.8653 21 16.4954 21 14V11C21 6.02944 16.9706 2 12 2C7.02944 2 3 6.02944 3 11V13M12 11V14C12 17.012 10.3354 19.6353 7.87598 21M14.3577 21C15.7101 19.0028 16.5 16.5937 16.5 14V11C16.5 8.51472 14.4853 6.5 12 6.5C9.51472 6.5 7.5 8.51472 7.5 11V14C7.5 15.933 5.933 17.5 4 17.5H3","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-fingerprint')
export default class FingerprintIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'fingerprint',
    }
  }
}
